// API DOC = https://swiperjs.com/swiper-api
import Swiper from 'swiper/bundle';
import {findMany} from '../helpers';

// Configuration options for the fade Swiper instances
const fadeOptions = {
    effect: 'fade',
    allowTouchMove: false,
    // centeredSlides: true,
    slidesPerView: 1,
    loop: true,
    speed: 600,
    parallax: true,
    fadeEffect: {
        crossFade: true,
    },
    threshold: 0,
    keyboard: {
        enabled: true,
    },
    spaceBetween: 24,
};

// Find all elements with the 'data-swipe-fade' attribute
const fadeElements = findMany('[data-swipe-fade]');

fadeElements.forEach(element => {
    return new Swiper(element, {
        ...fadeOptions,
        navigation: {
            nextEl: findMany('[data-swiper-next]', element),
            prevEl: findMany('[data-swiper-prev]', element),
        },
    });
});
